import { DatePipe, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  TemplateRef,
} from '@angular/core';
import { IScheduleCalendarDayContentContext } from '../../../directives/schedule-calendar-day-content.directive';
import {
  CALENDAR_HEIGHT,
  CALENDAR_HOURS,
  ICalendarDay,
  minutesToPixels,
} from '../../../utils/schedule-calendar.utils';

@Component({
  selector: 'app-schedule-calendar-day',
  templateUrl: './schedule-calendar-day.component.html',
  styleUrls: ['./schedule-calendar-day.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, NgTemplateOutlet],
})
export class ScheduleCalendarDayComponent {
  readonly day = input.required<ICalendarDay>();
  /** Minutes from the start of today */
  readonly nowMinutes = input.required<number>();
  /** What's shown on the day */
  readonly content = input<TemplateRef<IScheduleCalendarDayContentContext>>();

  readonly height = CALENDAR_HEIGHT;

  readonly hourLines = CALENDAR_HOURS.map(minutesToPixels);

  readonly nowTop = computed(() => minutesToPixels(this.nowMinutes()));

  readonly pastHeight = computed(() => {
    if (this.day().isInPast) {
      return this.height;
    }

    return this.day().isToday ? this.nowTop() : 0;
  });
}
